var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import gql from "graphql-tag";
import * as React from "react";
import { useMutation } from "react-apollo";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { SelectOrganizationRole, SelectUser, Spinner } from ".";
import i18next from "i18next";
var initState = {
    searchString: "",
    role: undefined,
};
var AssignOrganizationRoleModalGql = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation AssignOrganizationRoleModal(\n    $userId: String!\n    $role: OrganizationRole!\n  ) {\n    updateUser(userId: $userId, user: { role: $role }, options: {}) {\n      id\n      role\n    }\n  }\n"], ["\n  mutation AssignOrganizationRoleModal(\n    $userId: String!\n    $role: OrganizationRole!\n  ) {\n    updateUser(userId: $userId, user: { role: $role }, options: {}) {\n      id\n      role\n    }\n  }\n"])));
export var AssignOrganizationRoleModal = function (props) {
    var _a;
    var _b = React.useState(initState), state = _b[0], setState = _b[1];
    var close = function () {
        props.onClose();
        setState(initState);
    };
    var _c = useMutation(AssignOrganizationRoleModalGql, {
        variables: {
            userId: (_a = state.selectedUser) === null || _a === void 0 ? void 0 : _a.id,
            role: state.role,
        },
        refetchQueries: props.refetchQueries,
        awaitRefetchQueries: true,
        onCompleted: close,
        client: props.context.client,
    }), mutate = _c[0], operation = _c[1];
    return (React.createElement(Modal, { onClosed: props.onClose, isOpen: props.show, size: "lg" },
        React.createElement(ModalHeader, null, i18next.t("cc.assign.organization.role.modal.assignRole")),
        React.createElement(React.Fragment, null,
            React.createElement(ModalBody, null,
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", null, i18next.t("cc.assign.organization.role.modal.role")),
                    React.createElement(SelectOrganizationRole, { role: (state.role || null), onChange: (function (role) { return setState(function (p) { return (__assign(__assign({}, p), { role: role })); }); }), disableMemberRole: true })),
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { className: "form-label" }, i18next.t("cc.assign.organization.role.modal.user")),
                    React.createElement(SelectUser, { organizationId: props.organizationId, context: props.context, placeholder: i18next.t("cc.assign.organization.role.modal.socialSecurityNumberOrEmail"), searchText: state.searchString, onSearchTextChange: function (str) {
                            return setState(function (p) { return (__assign(__assign({}, p), { searchString: str })); });
                        }, onSelected: function (user) {
                            return setState(function (p) { return (__assign(__assign({}, p), { selectedUser: user })); });
                        } }),
                    state.selectedUser ? (React.createElement("table", { className: "table my-2 mx-1" },
                        React.createElement("tbody", null,
                            React.createElement("tr", { key: state.selectedUser.id, className: "py-2" },
                                React.createElement("td", null, state.selectedUser.name),
                                React.createElement("td", { className: "text-right align-middle" },
                                    React.createElement("button", { className: "btn btn-link p-0", onClick: function () {
                                            return setState(function (p) { return (__assign(__assign({}, p), { selectedUser: null })); });
                                        } }, i18next.t("cc.assign.organization.role.modal.remove"))))))) : null),
                operation.error ? (React.createElement("div", { className: "alert alert-danger" }, i18next.t("cc.assign.organization.role.modal.error"))) : null),
            React.createElement(ModalFooter, null,
                React.createElement("button", { className: "btn btn-secondary", onClick: close }, i18next.t("cc.assign.organization.role.modal.cancel")),
                React.createElement("button", { className: "btn btn-primary", onClick: function () { return mutate(); }, disabled: !state.selectedUser || !state.role }, operation.loading ? React.createElement(Spinner, null) : i18next.t("cc.assign.organization.role.modal.assign"))))));
};
var templateObject_1;
//# sourceMappingURL=AssignOrganizationRoleModal.js.map